import TableFooter from '@mui/material/TableFooter';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import MuiTablePagination from '@mui/material/TablePagination';

import { FORTA_GRAY4, FORTA_BLUE } from '../../utils/colors';

import type { MouseEvent } from 'react';

const rowsPerPageOptions = [10, 20, 30, 100];

interface AdminTableFooterProps {
  count: number;
  page: number;
  rowsPerPage: number;
  changeRowsPerPage: (page: string | number) => void;
  changePage: (newPage: number) => void;
}

const AdminTableFooter = ({
  count,
  page,
  rowsPerPage,
  changeRowsPerPage,
  changePage,
}: AdminTableFooterProps) => {
  const handleRowChange = (value: string | number) => {
    changeRowsPerPage(value);
  };
  const handlePageChange = (page: number) => {
    changePage(page);
  };

  const footerStyle = {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '10px 24px 10px 24px',
  };

  return (
    <TableFooter>
      <TableRow>
        <TableCell style={footerStyle}>
          <MuiTablePagination
            component="div"
            count={count}
            rowsPerPage={rowsPerPage}
            page={page}
            rowsPerPageOptions={rowsPerPageOptions}
            onPageChange={(_: MouseEvent<HTMLButtonElement> | null, page: number) =>
              handlePageChange(page)
            }
            onRowsPerPageChange={(e) => handleRowChange(e.target.value)}
            showFirstButton
            showLastButton
            sx={{
              '.MuiTablePagination-toolbar': {
                color: FORTA_GRAY4,
                height: '36px',
              },
              '.MuiTablePagination-displayedRows': {
                marginBottom: 0,
              },
              '.MuiTablePagination-selectLabel': {
                marginBottom: 0,
              },
              '.MuiTablePagination-input': {
                padding: 1,
                backgroundColor: FORTA_BLUE.light3,
                borderRadius: '10px',
              },
              '.MuiButtonBase-root': {
                margin: '0 10px',
                backgroundColor: FORTA_BLUE.light3,
              },
            }}
          />
        </TableCell>
      </TableRow>
    </TableFooter>
  );
};

export default AdminTableFooter;
